import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import HAttachment from "@cloudpivot/form/src/common/components/attachment.vue";
let Attachment = class Attachment extends Vue {
    constructor() {
        super(...arguments);
        this.displayTemplate = false;
    }
    controlChange(val) {
        this.displayTemplate = this.control.options.displayTemplate || false;
    }
    render(h) {
        console.log(this.control, 'control');
        return h('h-attachment', {
            props: {
                disabled: true,
                text: "点击或拖拽上传",
                displayTemplate: this.displayTemplate,
            }
        });
    }
};
tslib_1.__decorate([
    Prop()
], Attachment.prototype, "control", void 0);
tslib_1.__decorate([
    Watch('control', {
        immediate: true,
        deep: true
    })
], Attachment.prototype, "controlChange", null);
Attachment = tslib_1.__decorate([
    Component({ name: 'Attachment', components: { HAttachment } })
], Attachment);
export default Attachment;
